
















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/atoms/Grid/Container.vue';
import Subtitle from '@/components/molecules/Typography/Subtitle.vue';
import Description from '@/components/molecules/Typography/Description.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import eventBus from '@/utils/eventBus';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';
import TextField from '@/components/atoms/TextField/TextField.vue';
import FlagsService, { IFlagUpdate } from '@/api/FlagsService';

interface ICustomer {
  id: string;
  label?: string;
  name: string;
  lastname: string;
  mail: string;
}

interface IBusiness {
  id: string;
  label?: string;
  name: string;
  city: string;
  state: string;
}

@Component({
  components: {
    FilledButton,
    TextInput,
    FormLabel,
    Description,
    Subtitle,
    Container,
    Checkbox,
    SelectorAndList,
    TextField
  }
})
export default class EditFlagModal extends Vue {
  @Prop() readonly data!: any;

  loading = false;
  adminService = new AdminService();
  flagService = new FlagsService();
  businesses: IBusiness[] = this.mapBusinesses(
    this.data.groups[0] && this.data.groups[0].businesses
  );
  businessesOptions: IBusiness[] = [];
  customers: ICustomer[] = this.mapCustomers(
    this.data.groups[0] && this.data.groups[0].customers
  );
  customersOptions: ICustomer[] = [];

  enableForAllAppVersions =
    (this.data.androidVersion === '0' && this.data.iosVersion === '0') ||
    (!this.data.androidVersion && !this.data.iosVersion);

  androidVersion: string =
    this.data.androidVersion === '0' ? '' : this.data.androidVersion;
  iosVersion: string = this.data.iosVersion === '0' ? '' : this.data.iosVersion;

  async searchBusinesses(search: string) {
    try {
      const { data } = await this.adminService.searchBusinesses(search);
      const selectedIds = new Set(this.businesses.map(c => c.id));
      this.businessesOptions = this.mapBusinesses(
        data.items.filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.businessesOptions = [];
      this.$notification(treatError(e));
    }
  }

  async searchCustomers(search: string) {
    try {
      const { data } = await this.adminService.searchCustomers(search);
      const selectedIds = new Set(this.customers.map(c => c.id));
      this.customersOptions = this.mapCustomers(
        data.items
          .map(({ customer }: any) => customer)
          .filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.customersOptions = [];
      this.$notification(treatError(e));
    }
  }

  changeStatus() {
    if (this.data.status === 'enabled') {
      this.data.status = 'disabled';
    } else {
      this.data.status = 'enabled';
    }
  }

  get isTextAreaDisabled() {
    return this.data.status === 'enabled';
  }

  async save() {
    try {
      this.loading = true;

      const flagBody: IFlagUpdate = {
        status: this.data.status,
        groups: [
          {
            id: this.data.groups[0] && this.data.groups[0].id,
            name: `Tester users for ${this.data.slug}`,
            customers: this.customers.map(item => item.id),
            businesses: this.businesses.map(item => item.id)
          }
        ]
      };

      flagBody.androidVersion = this.enableForAllAppVersions
        ? '0'
        : this.androidVersion.trim() || '0';
      flagBody.iosVersion = this.enableForAllAppVersions
        ? '0'
        : this.iosVersion.trim() || '0';

      const { data } = await this.flagService.changeStatus(
        this.data.id,
        flagBody
      );

      Object.assign(this.data, data);
      this.$notification('Success');
      this.closeModal();
    } catch (e) {
      console.error(e);
      this.$notification(treatError(e));
    } finally {
      this.loading = false;
    }
  }

  mapCustomers(customers: ICustomer[] = []) {
    return customers.map(customer => {
      return {
        label: `${customer.name} ${customer.lastname} (${customer.mail})`,
        ...customer
      };
    });
  }

  mapBusinesses(businesses: IBusiness[] = []) {
    return businesses.map(business => {
      return {
        label: `${business.name} (${getBusinessLocationInfo(business)})`,
        ...business
      };
    });
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', false);
  }
}
